import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getNotifications } from "../repositories/userRepo";


const initialState = {
  data: [
    {"text":"welcome","date":"22/02/2022 12"},
  ],
  loading: false,
  error: null,
};
export const getNotificationsData = createAsyncThunk("notifications", async (thunkAPI) => {
  const response = await getNotifications();
  return response;
});
export const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  extraReducers: {
    [getNotificationsData.pending]: (state) => {
      state.loading = true;
    },
    [getNotificationsData.fulfilled]: (state, action) => {
      state.loading = false;
      const data = [
         {"text":"hello","date":"16/02/2022 12"},
         {"text":"you have new messages","date":"19/02/2022 12"},
         {"text":"welcome","date":"22/02/2022 12"},
         {"text":"you have new messages","date":"10/02/2020 12"},
         {"text":"you send new message","date":"10/06/2021 12 12"},
         {"text":"you add new group today","date":"10/02/2023 12"},
         {"text":"you send new message","date":"10/02/2021 12"},
         {"text":"you send new message","date":"10/02/2019 12"},
      ];
      state.data = data;
      //state.data= action.payload
    },
    [getNotificationsData.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default notificationsSlice.reducer;
